/**
 * Feature flags controlled via environment variables.
 *
 * VITE_SHOW_DELETE_COLUMN — set to "true" to show the delete column in all data tables.
 * Default: false (hidden). Enable when requested by a stakeholder.
 */
export const showDeleteColumn =
	import.meta.env.VITE_SHOW_DELETE_COLUMN === 'true';
